import createReactComponent from '../createReactComponent';
export default createReactComponent('clock-hour-12', 'IconClockHour12', [
  ['path', { d: 'M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0', key: 'svg-0' }],
  ['path', { d: 'M12 7v5', key: 'svg-1' }],
]);
